import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuLandingPageTypeAppResource from './LuLandingPageTypeAppResource';

export const INDUSTRY_PROFESSIONAL = '0250c900-b334-4785-99bf-6d9ba96d53d1';
export const LIFE_EVENT = '63aff0f6-240f-4989-892a-b2b4770778eb';
export const TOPIC_OF_INTEREST = 'f90d270a-a112-4fe2-94ed-f312b875eef1';
export const LOCATION = 'd77061e6-506a-42a5-9c16-292b5806e8e2';
export const PROPERTY = '140c36c5-41d0-4d75-8901-b2a71712e019';

export const ALL = {
    INDUSTRY_PROFESSIONAL,
    LIFE_EVENT,
    TOPIC_OF_INTEREST,
    LOCATION,
    PROPERTY,
};

class LuLandingPageCategoryAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-landing-page-category';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/landings/pages/categories';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'slug',
            'title',
            'description',
            'types',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            types: LuLandingPageTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuLandingPageCategoryAppResource;
